<div class="animation-wrapper">
  <div class="animation-view">
    <img src="../../assets/images/animation_success.gif" alt="" />
  </div>

  <div class="animation-text-wrapper">
    <h5>Thank You!</h5>
    <p>Your forms was successfully submitted!</p>

    <button class="submitBtn">
      Continue
    </button>

  </div>
</div>
